import { render } from "./ImagePicker.vue?vue&type=template&id=229e5edf&scoped=true"
import script from "./ImagePicker.vue?vue&type=script&lang=js"
export * from "./ImagePicker.vue?vue&type=script&lang=js"

import "./ImagePicker.vue?vue&type=style&index=0&id=229e5edf&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229e5edf"]])

export default __exports__